import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Modal from '../shared/Modal'

const PrivacyPolicy = ({ isOpen, onClose, onAccept }) => {
  const { t, i18n } = useTranslation()
  const today = new Date().toLocaleDateString(i18n.language)

  // Рендер текста с поддержкой <0>, <1>, ссылок и т.д.
  const renderContent = content => {
    if (!content) return null
    const items = Array.isArray(content) ? content : [content]
    return items.map((text, idx) => (
      <p key={idx} className='mb-2'>
        <Trans
          i18nKey={text}
          components={[
            <strong key='0' />,
            <strong key='1' />,
            <strong key='2' />,
            <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
          ]}
        />
      </p>
    ))
  }

  const renderList = list => {
    if (!list) return null
    const items = Array.isArray(list) ? list : [list]
    return (
      <ul className='list-disc pl-6 mt-2 mb-4'>
        {items.map((item, idx) => (
          <li key={idx}>
            <Trans
              i18nKey={item}
              components={[
                <strong key='0' />,
                <strong key='1' />,
                <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
              ]}
            />
          </li>
        ))}
      </ul>
    )
  }
  const renderP = paragraph => {
    if (!paragraph) return null
    const items = Array.isArray(paragraph) ? paragraph : [paragraph]
    return (
      <ul className='list-disc pl-6 mt-2 mb-4'>
        {items.map((item, idx) => (
          <li key={idx}>
            <Trans
              i18nKey={item}
              components={[
                <strong key='0' />,
                <strong key='1' />,
                <a key='link' href='https://swipey.ai/' target='_blank' rel='noopener noreferrer' />,
              ]}
            />
          </li>
        ))}
      </ul>
    )
  }

  const renderSection = section => (
    <div key={section.key} className='policy-section mb-6'>
      <h3 className='font-semibold text-lg mb-2'>{section.title}</h3>

      {renderContent(section.content)}
      {renderList(section.list)}
      {renderP(section.paragraph)}

      {section.note && <p className='italic text-sm mt-2'>{section.note}</p>}

      {section.contact &&
        section.contact.map((c, idx) => (
          <p key={idx}>
            <Trans i18nKey={c} components={[<strong key='0' />, <a key='link' href='mailto:admin@invai.tech' />]} />
          </p>
        ))}

      {section.subsections &&
        section.subsections.map((sub, idx) => (
          <div key={idx} className='subsection pl-4 mt-4'>
            <h4 className='font-medium mb-1'>{sub.title}</h4>
            {renderContent(sub.content)}
            {renderList(sub.list)}
          </div>
        ))}
    </div>
  )

  // Берём все секции сразу
  const sections = t('privacy.sections', { returnObjects: true })

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      title={t('privacy.title')}
      acceptText={t('privacy.accept')}
      closeText={t('privacy.close')}
      maxWidth='1000px'
    >
      <div className='privacy-policy-content overflow-y-auto max-h-[80vh] px-4'>
        <p className='last-updated mb-4'>{t('privacy.last_updated', { date: today })}</p>
        {sections.map(section => renderSection(section))}
      </div>
    </Modal>
  )
}

export default PrivacyPolicy
